import styled from "styled-components"

export const Border = styled.rect``
export const BigSquare = styled.rect``
export const SmallSquare = styled.foreignObject``

export const Svg = styled.svg<{
  width?: number
  height?: number
}>`
  width: ${({ width }) => (width ? `${width}px` : 0)};
  height: ${({ height }) => (height ? `${height}px` : 0)};
`

export const ValueWrap = styled.div<{
  mainColor: string
}>`
  ${getFlexbox({ flow: "column" })}
  min-width: 100%;
  min-height: 100%;

  position: relative;

  z-index: 1;
  background: ${({ mainColor }) => mainColor};
`

export const FormattedValueWrap = styled.span<{
  width?: number
}>`
  ${getFlexbox({ align: "baseline" })}
  width: ${({ width }) => (width ? `${width}px` : "max-content")};
`

export const DeltaWrap = styled.div<{ isCentered?: boolean }>`
  ${({ isCentered }) =>
    getFlexbox({ justify: isCentered ? "center" : "flex-end" })}
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 0.5rem;
  margin-right: ${({ isCentered }) => (isCentered ? 0 : 0.5)}rem;
`

// component used to wrap the component in the docs to display it aligned in the center and with a standarized height
export const DocsWrap = styled.div`
  ${getFlexbox()}
  min-height: 400px;
`

interface IGetFlexboxProps {
  flow?: string
  wrap?: string
  align?: string
  justify?: string
}

function getFlexbox({
  flow = "row",
  wrap = "nowrap",
  align = "center",
  justify = "center"
}: IGetFlexboxProps = {}) {
  return `
    display: flex;
    flex-flow: ${flow} ${wrap};
    align-items: ${align};
    justify-content: ${justify};
  `
}
